import React, {useState, useEffect} from 'react';
import {Button, ButtonGroup} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import shuffle from '../util/shuffleArray';

const ProviderReviewsList = (props) => {
    const {t} = useTranslation();

    const [providerReviews, setProviderReviews] = useState(null);
    const [currentReview, setCurrentReview] = useState(0);

    useEffect(() => {
        if (providerReviews === null) {
            const newProvidedReviews = [];

            if (props.APIDataProvider.reviews.feedbacks) {
                for (let feedback of props.APIDataProvider.reviews.feedbacks) {
                    if (feedback.message !== null && feedback.message.length > 0) {
                        newProvidedReviews.push(feedback.message);
                    }
                }
            }
            console.log(newProvidedReviews)

            setProviderReviews(shuffle(newProvidedReviews));
        }
    }, [providerReviews, props])

    return <>
        <div
            style={{
                display: "flex",
                alignItems: "center",
                flexWrap: 'wrap'
            }}
        >
            <h5
                className="mb-0 pr-3 mr-auto"
                style={{
                    paddingBottom: '1rem'
                }}
            >{t("Provider.reviews")}</h5>
            {
                providerReviews !== null && providerReviews.length > 1 &&
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: '1rem'
                    }}
                >
                    <div
                        style={
                            {
                                flexBasis: 'max-content',
                            }
                        }
                    >
                        {
                            providerReviews !== null && providerReviews.length > 0 && <span className="text-muted">{currentReview + 1}{t("Provider.out-of")}{providerReviews.length}</span>
                        }
                    </div>
                    <div
                        className="ml-3"
                    >
                        <ButtonGroup>
                            <Button
                                size="sm"
                                variant="outline-primary"
                                disabled={providerReviews === null}
                                onClick={() => {
                                    if (currentReview === 0) {
                                        setCurrentReview(providerReviews.length - 1)
                                    } else {
                                        setCurrentReview(currentReview - 1)
                                    }
                                }}
                            >
                                {t("Provider.review-previous")}
                            </Button>
                            <Button
                                size="sm"
                                variant="outline-primary"
                                disabled={providerReviews === null}
                                onClick={
                                    () => {
                                        if (currentReview === providerReviews.length - 1) {
                                            setCurrentReview(0)
                                        } else {
                                            setCurrentReview(currentReview + 1)
                                        }
                                    }
                                }
                            >
                                {t("Provider.review-next")}
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            }

        </div>

        <div
            style={{
                marginTop: "1.5rem",
                lineHeight: "1.6",
                maxWidth: "32rem",
                marginBottom: 0,
            }}
        >
            <style>
                {/* {` */}
                {/*     p.provider-review-item:before { */}
                {/*         content: '“' */}
                {/*     } */}
                {/*     p.provider-review-item:after { */}
                {/*         content: '”' */}
                {/*     } */}
                {/* `} */}
            </style>
            {providerReviews !== null && providerReviews.length > 0 ? <p className="provider-review-item">
                <em>{providerReviews[currentReview]}</em>

            </p> : <p className="text-muted">{t('Provider.message-no-reviews')}</p>
            }
        </div>
    </>
}

export default ProviderReviewsList;
